/// <amd-module name="Feed/Admin/Redux/GlobalSettings/GlobalSettingsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { reduceReducers } from "redux/Utils/ReducerHelper";

import { GlobalSettingsActions } from "./GlobalSettingsActions";
import { IGlobalSettingsAwareState } from "./GlobalSettingsContracts";
import { globalSettingsReducer, initialGlobalSettingsState } from "./GlobalSettingsReducers";
import rootSaga from "./GlobalSettingsSaga";

export const GlobalSettingsModule: ISagaModule<IGlobalSettingsAwareState> = {
    id: "feed-global-settings",
    reducerMap: {
        globalSettingsState: reduceReducers(initialGlobalSettingsState(), globalSettingsReducer)
    },
    sagas: [rootSaga],
    initialActions: [GlobalSettingsActions.loadPermissions()]
};
